<div class="create-tramites-container">
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-md-8">
        <h2 class="page-title">
          <i class="fa fa-plus-circle"></i> Agregar Nuevo Trámite
        </h2>
        <p class="subtitle">Complete el formulario para registrar un nuevo trámite en el catálogo</p>
      </div>
      <div class="col-md-4 text-right align-self-center">
        <button type="button" class="btn btn-secondary" (click)="cancel()">
          <i class="fa fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isLoading">
          <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-save'"></i> 
          {{ isLoading ? 'Guardando...' : 'Guardar Trámite' }}
        </button>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      
      <!-- Sección: Información Básica -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="fa fa-info-circle"></i> Información Básica</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Nombre del Trámite <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="nombreTramite" 
                [class.is-invalid]="hasError('nombreTramite')" placeholder="Ej: Certificado de No Adeudo">
              <div class="invalid-feedback" *ngIf="hasError('nombreTramite')">
                {{ getErrorMessage('nombreTramite') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Código del Trámite <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="codigoTramite" 
                [class.is-invalid]="hasError('codigoTramite')" placeholder="Ej: CNA001">
              <div class="invalid-feedback" *ngIf="hasError('codigoTramite')">
                {{ getErrorMessage('codigoTramite') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Tipo de Trámite <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="tipoTramite" [class.is-invalid]="hasError('tipoTramite')">
                <option value="">Seleccione un tipo</option>
                <option *ngFor="let tipo of tiposTramite" [value]="tipo.value">{{ tipo.label }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('tipoTramite')">
                {{ getErrorMessage('tipoTramite') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Categoría <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="categoria" [class.is-invalid]="hasError('categoria')">
                <option value="">Seleccione una categoría</option>
                <option *ngFor="let cat of categorias" [value]="cat.id">{{ cat.ValueAlpha || cat.Name }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('categoria')">
                {{ getErrorMessage('categoria') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Dependencia <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="dependencia" [class.is-invalid]="hasError('dependencia')">
                <option value="">Seleccione una dependencia</option>
                <option *ngFor="let dep of dependencias" [value]="dep.id">{{ dep.ValueAlpha || dep.Name }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('dependencia')">
                {{ getErrorMessage('dependencia') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Área <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="area" [class.is-invalid]="hasError('area')">
                <option value="">Seleccione un área</option>
                <option *ngFor="let area of areas" [value]="area.id">{{ area.ValueAlpha || area.Name }}</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('area')">
                {{ getErrorMessage('area') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Solicitante <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="tipoSolicitante" 
                [class.is-invalid]="hasError('tipoSolicitante')"
                (change)="onTipoSolicitanteChange()">
                <option value="">Seleccione un tipo</option>
                <option value="Física">Persona Física</option>
                <option value="Moral">Persona Moral</option>
                <option value="Ambos">Ambos</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('tipoSolicitante')">
                {{ getErrorMessage('tipoSolicitante') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Modalidades -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-success text-white">
          <h5 class="mb-0"><i class="fa fa-laptop"></i> Modalidades de Atención</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="modalidadEnLinea" formControlName="modalidadEnLinea">
                <label class="form-check-label" for="modalidadEnLinea">En Línea</label>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="modalidadPresencial" formControlName="modalidadPresencial">
                <label class="form-check-label" for="modalidadPresencial">Presencial</label>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="modalidadConCita" formControlName="modalidadConCita">
                <label class="form-check-label" for="modalidadConCita">Con Cita</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Tiempos y Vigencia -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-info text-white">
          <h5 class="mb-0"><i class="fa fa-clock"></i> Tiempos y Vigencia</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">Tiempo de Respuesta <span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="tiempoRespuesta" 
                [class.is-invalid]="hasError('tiempoRespuesta')" min="0" placeholder="0">
              <div class="invalid-feedback" *ngIf="hasError('tiempoRespuesta')">
                {{ getErrorMessage('tiempoRespuesta') }}
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Tipo de Tiempo <span class="text-danger">*</span></label>
              <select class="form-select" formControlName="tipoTiempoRespuesta" [class.is-invalid]="hasError('tipoTiempoRespuesta')">
                <option value="Días hábiles">Días hábiles</option>
                <option value="Días naturales">Días naturales</option>
                <option value="Horas">Horas</option>
              </select>
              <div class="invalid-feedback" *ngIf="hasError('tipoTiempoRespuesta')">
                {{ getErrorMessage('tipoTiempoRespuesta') }}
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Vigencia del Documento</label>
              <input type="number" class="form-control" formControlName="vigencia" min="0" placeholder="0">
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">Tipo de Vigencia</label>
              <select class="form-select" formControlName="tipoVigencia">
                <option value="Días naturales">Días naturales</option>
                <option value="Días hábiles">Días hábiles</option>
                <option value="Años">Años</option>
                <option value="Meses">Meses</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Descripción del Trámite -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-warning text-dark">
          <h5 class="mb-0"><i class="fa fa-file-text"></i> Descripción del Trámite</h5>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label">Descripción <span class="text-danger">*</span></label>
            <textarea class="form-control" formControlName="descripcion" rows="4" 
              [class.is-invalid]="hasError('descripcion')" 
              placeholder="Describa detalladamente el trámite..."></textarea>
            <div class="invalid-feedback" *ngIf="hasError('descripcion')">
              {{ getErrorMessage('descripcion') }}
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Fundamento Jurídico <span class="text-danger">*</span></label>
            <textarea class="form-control" formControlName="fundamentoJuridico" rows="4" 
              [class.is-invalid]="hasError('fundamentoJuridico')" 
              placeholder="Mencione las leyes, reglamentos o normativas que rigen este trámite..."></textarea>
            <div class="invalid-feedback" *ngIf="hasError('fundamentoJuridico')">
              {{ getErrorMessage('fundamentoJuridico') }}
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Requisitos</label>
              <textarea class="form-control" formControlName="requisitos" rows="3" 
                placeholder="Liste los requisitos necesarios para el trámite..."></textarea>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Observaciones</label>
              <textarea class="form-control" formControlName="observaciones" rows="3" 
                placeholder="Observaciones adicionales..."></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Información de Oficina -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-secondary text-white">
          <h5 class="mb-0"><i class="fa fa-building"></i> Información de Oficina</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Oficina</label>
              <input type="text" class="form-control" formControlName="nombreOficina" 
                placeholder="Ej: Tesorería Municipal">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Teléfono de Oficina</label>
              <input type="text" class="form-control" formControlName="telefonoOficina" 
                placeholder="Ej: (229) 200-2000">
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label">Dirección</label>
              <input type="text" class="form-control" formControlName="direccionOficina" 
                placeholder="Calle y número">
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label">Horario de Atención</label>
              <input type="text" class="form-control" formControlName="horarioAtencion" 
                placeholder="Ej: L-V 9:00-18:00">
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Información de Consulta -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-dark text-white">
          <h5 class="mb-0"><i class="fa fa-question-circle"></i> Información de Consulta</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Atendido por <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="nombreContacto" 
                [class.is-invalid]="hasError('nombreContacto')" placeholder="Nombre del responsable">
              <div class="invalid-feedback" *ngIf="hasError('nombreContacto')">
                {{ getErrorMessage('nombreContacto') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Cargo</label>
              <input type="text" class="form-control" formControlName="cargoContacto" 
                placeholder="Ej: Director de Tesorería">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Teléfono <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="telefonoContacto" 
                [class.is-invalid]="hasError('telefonoContacto')" placeholder="Teléfono de contacto">
              <div class="invalid-feedback" *ngIf="hasError('telefonoContacto')">
                {{ getErrorMessage('telefonoContacto') }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="emailContacto" 
                [class.is-invalid]="hasError('emailContacto')" placeholder="correo@ejemplo.com">
              <div class="invalid-feedback" *ngIf="hasError('emailContacto')">
                {{ getErrorMessage('emailContacto') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Costo -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0"><i class="fa fa-dollar-sign"></i> Costo del Trámite</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="esGratuito" formControlName="esGratuito"
                  (change)="onEsGratuitoChange()">
                <label class="form-check-label" for="esGratuito">
                  Trámite Gratuito
                </label>
              </div>
            </div>

            <div class="col-md-6 mb-3" *ngIf="!form.get('esGratuito')?.value">
              <label class="form-label">Costo</label>
              <input type="number" class="form-control" formControlName="costo" 
                [class.is-invalid]="hasError('costo')" min="0" step="0.01" placeholder="0.00">
              <div class="invalid-feedback" *ngIf="hasError('costo')">
                {{ getErrorMessage('costo') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección: Configuración -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-danger text-white">
          <h5 class="mb-0"><i class="fa fa-cog"></i> Configuración</h5>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isVisible" formControlName="isVisible">
                <label class="form-check-label" for="isVisible">Visible</label>
                <p class="small text-muted">Mostrar en catálogo público</p>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isLimited" formControlName="isLimited">
                <label class="form-check-label" for="isLimited">Limitado</label>
                <p class="small text-muted">Limitar solicitudes por ciudadano</p>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" id="isRequestable" formControlName="isRequestable">
                <label class="form-check-label" for="isRequestable">Solicitable</label>
                <p class="small text-muted">Permitir solicitudes de este trámite</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="row mb-4">
        <div class="col-12 text-center">
          <button type="button" class="btn btn-secondary btn-lg mr-2" (click)="cancel()">
            <i class="fa fa-times"></i> Cancelar
          </button>
          <button type="submit" class="btn btn-primary btn-lg" [disabled]="isLoading || form.invalid">
            <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-save'"></i> 
            {{ isLoading ? 'Guardando...' : 'Guardar Trámite' }}
          </button>
        </div>
      </div>

    </form>
  </div>
</div>



